module.exports = __webpack_public_path__ + "img/christmas-island.7ce715e7.svg";